<template>
  <div class="card">
    <div class="card-body">
      <b-table
        class="datatables"
        responsive="sm"
        :fields="fields" 
        :current-page="currentPage"
        per-page="10"
        :items="items"

        bordered
        striped
      >
        <template #cell(interacao)="data">
          <div class="d-flex">
            <b-button
              size="sm"
              variant="primary"
              class="me-1"
              @click="carregarRegistrosImportados(data.item)" >
              <i class="mdi mdi-eye"></i>
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="d-flex justify-content-end mt-3">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="itemsPerPage"
          class="pagination pagination-rounded mb-0" />
      </div>
    </div>
  </div>
</template>

<script>
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";

export default {
  mixins: [clienteRuralMixin],
  name: 'Grid',
  props: {
    filtro: {
      type: Object,
      default: () => ({})
    },
    items: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      sortField: '',
      sortOrder: '',
      loadingAcoes: false,
      fields: [
        { key: 'nr_plano', label: 'Nº Projeto', sortable: true },
        { key: 'sq_produtor', label: 'Cliente Rural ', sortable: true },
        { key: 'sq_produtor2', label: 'CPF/CNPJ', sortable: true },
        { key: 'interacao', label: '' }
      ],
    };
  },
  computed: {
    totalRows() {
      return this.items.length;
    },
  },

  methods: {
    carregarRegistrosImportados(item) {
      console.log("Emitir editar item", item);
      this.$emit("editarItem", item);
      this.$router.push("loteImportacao/registrosImportados");
    },
  },
};
</script>

<style scoped>
.sortable-header {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.sort-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5px;
}

</style>
